export const namespace = "lock/";
export const SET_LOCK = `SET_LOCK`;
